_collow.components.QuizSingleAnswer = class QuizSingleAnswer extends (
  _collow.components.Base
) {
  root;
  elements;
  params;
  questionElements;
  answer;
  studentAnswer;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.questionElements = Array.from(root.childNodes)
      .filter(node => 
        node.nodeType === Node.ELEMENT_NODE && 
        typeof node.hasAttribute === 'function' &&
        node.hasAttribute("data-question")
      );
    this.questionElements.forEach(
      (el, index) => (el.dataset.quizIndex = index)
    );

    this.getAnswers();
    this.removeHintsAndExplanations();

    this.questionElements.forEach((el) =>
      this.listen(el, "click", this.changeSelected)
    );
    this.listen(document.body, "_collow.quiz-finished", this.showResults);
  }

  changeSelected = ({ target }) => {
    const targetEl = target.closest(".question-option");
    const state = targetEl.dataset.quizItemSelected == "false" ? false : true;
    this.questionElements.forEach((el) => {
      el.dataset.quizItemSelected = false;
      el.querySelector("input").checked = false;
    });

    targetEl.dataset.quizItemSelected = `${!state}`;
    targetEl.querySelector("input").checked = !state;
    this.studentAnswer = targetEl.dataset.quizIndex;
    this.sendAnswer();
  };

  sendAnswer = () => {
    const earnedPoints =
      this.studentAnswer == this.answer ? this.params.points : 0;

    this.dispatch(this.root, "_collow.quiz-points", {
      points: earnedPoints,
      index: this.params.index,
    });
  };

  getAnswers = () => {
    this.questionElements.forEach((el, ind) => {
      if (el.dataset.quizAnswer == "true") this.answer = ind;
    });

    this.questionElements.forEach((el) => {
      el.removeAttribute("data-quiz-answer");
    });
  };

  removeHintsAndExplanations = () =>
    [
      "data-quiz-single-answer:explanation-correct",
      "data-quiz-single-answer:explanation-wrong",
      "data-quiz-single-answer:hint",
    ].forEach((attr) => this.root.removeAttribute(attr));

  showResults = () => {
    this.questionElements.forEach((el) =>
      this.unlisten(el, "click", this.changeSelected)
    );
    this.questionElements[this.answer].dataset.quizCorrectAnswer = true;
    let correct = true;
    if (this.studentAnswer != this.answer && this.studentAnswer) {
      this.questionElements[
        this.studentAnswer
      ].dataset.quizCorrectAnswer = false;
      correct = false;
    }
    this.dispatch(this.root, `_collow.hint-${this.params.index}`, correct);
    this.dispatch(this.root, "_collow.quiz-finished", { correct }, false);
  };
};
